'use client';

import { c as _c } from "react/compiler-runtime";
import { ErrorServiceUnavailable } from '@/components/common/Error';
import SectionErrorBoundary from '@/components/common/SectionErrorBoundary';
import { ResponsiveDashboardContextProvider } from '@/contexts/Dashboard/Dashboard.context';
import { useIsMedium } from '@/hooks/useBreakpoints';
import AdlSunsetNudgeWatcher from '../AdlSunsetNudge/AdlSunsetNudgeWatcher';
import { DashboardBorrowHero } from '../DashboardBorrowHero';
import DashboardHeroTitle from '../DashboardHeroTitle';
import { useBorrowPositionsTotals } from '../hooks/useDashboardTotals';
import DashboardBorrowPositionsDesktopView from './components/DashboardBorrowPositionsDesktopView';
import DashboardBorrowPositionsMobileView from './components/DashboardBorrowPositionsMobileView';
import { useDashboardBorrowPositionsTable } from './hooks/useDashboardBorrowPositionsTable';
import DashboardBorrowPositionsEmptyState from './states/DashboardBorrowPositionsEmptyState';
import DashboardBorrowPositionsSkeleton from './states/loading/DashboardBorrowPositionsSkeleton';
const DashboardBorrowPositions = () => {
  const $ = _c(26);
  const isMobile = useIsMedium();
  const {
    borrowPositions,
    borrowPositionsRows,
    facets,
    partial,
    loading,
    error,
    table,
    filters,
    handleFiltersChange,
    positionChainIds,
    columnLabels
  } = useDashboardBorrowPositionsTable();
  const {
    hasNoPositions
  } = useBorrowPositionsTotals(borrowPositionsRows);
  const unavailable = Boolean(error) || partial && borrowPositions.length === 0;
  let t0;
  if ($[0] !== borrowPositions) {
    t0 = <AdlSunsetNudgeWatcher borrowPositions={borrowPositions} />;
    $[0] = borrowPositions;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DashboardHeroTitle title="Variable Rate Markets" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ResponsiveDashboardContextProvider><div className="flex flex-col gap-12">{t1}<SectionErrorBoundary fallback={null} section="DashboardBorrowHero" route="/portfolio"><DashboardBorrowHero /></SectionErrorBoundary></div></ResponsiveDashboardContextProvider>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="text-foreground text-sm">Borrow positions</span>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== partial || $[6] !== unavailable) {
    t4 = partial && !unavailable ? <p data-testid="dashboard-borrow-positions-partial-notice" className="text-secondary-foreground text-sm">Some positions could not be loaded, so this list and its totals may be incomplete.</p> : null;
    $[5] = partial;
    $[6] = unavailable;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== borrowPositions || $[9] !== columnLabels || $[10] !== facets || $[11] !== filters || $[12] !== handleFiltersChange || $[13] !== hasNoPositions || $[14] !== isMobile || $[15] !== loading || $[16] !== positionChainIds || $[17] !== table || $[18] !== unavailable) {
    t5 = unavailable ? <ErrorServiceUnavailable /> : loading ? <DashboardBorrowPositionsSkeleton /> : hasNoPositions ? <DashboardBorrowPositionsEmptyState /> : isMobile ? <DashboardBorrowPositionsMobileView table={table} filters={filters} onFiltersChange={handleFiltersChange} positionChainIds={positionChainIds} loading={loading} disabled={false} totalPositionsCount={borrowPositions.length} facets={facets} /> : <DashboardBorrowPositionsDesktopView table={table} filters={filters} onFiltersChange={handleFiltersChange} positionChainIds={positionChainIds} columnLabels={columnLabels} borrowPositions={borrowPositions} loading={loading} disabled={false} facets={facets} />;
    $[8] = borrowPositions;
    $[9] = columnLabels;
    $[10] = facets;
    $[11] = filters;
    $[12] = handleFiltersChange;
    $[13] = hasNoPositions;
    $[14] = isMobile;
    $[15] = loading;
    $[16] = positionChainIds;
    $[17] = table;
    $[18] = unavailable;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== t4 || $[21] !== t5) {
    t6 = <div className="flex flex-col gap-6">{t3}{t4}{t5}</div>;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== t0 || $[24] !== t6) {
    t7 = <div className="flex flex-col gap-12">{t0}{t2}{t6}</div>;
    $[23] = t0;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  return t7;
};
export default DashboardBorrowPositions;